import classNames from 'classnames'
import { ReactNode } from 'react'

import './container.style.css'

interface Props {
  children: ReactNode
  title?: string
  hint?: string
  backgroundless?: boolean
}

const TitledContainer = ({ children, title = '', hint = '', backgroundless }: Props) => {
  const classname = classNames('titled-container__wrapper', {
    'titled-container__wrapper-backgound ': !backgroundless,
  })

  return (
    <div className="titled-container">
      <div className={classname}>
        {title !== '' ? <h2>{title}</h2> : null}
        {hint !== '' ? <span className="hint titled-container__hint divider">{hint}</span> : null}
        {children}
      </div>
    </div>
  )
}

export default TitledContainer
